module.exports = __webpack_public_path__ + "resources/img/logo_PixelCube.470008777f0f99fe34fd6e204490360e.png";